import { Component, ChangeDetectionStrategy, OnInit, Input, OnDestroy, Optional } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { ResourceplanStore } from './resourceplan.store';
import { ActivatedRoute, Router } from '@angular/router';
import { CasesDispatchers, CasesService } from '../../../cases/store/services';
import { TimeBudget } from '../../../../../timetrack/store/models';
import { SagView } from '../../../cases/models';
import { EMPTY, Observable } from 'rxjs';
import { AlertService } from '../../../../../core/alerts/alert.service';
import { IndexCard } from '../../../../../auth/store/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-resourceplan-ui',
    templateUrl: './resourceplan.component.html',
    styleUrls: ['./resourceplan.component.scss'],
    providers: [ResourceplanStore],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResourceplanComponent implements OnInit, OnDestroy {
    @Input() sagId: number;
    @Input() isModal = false;
    vm$ = this.resourceplanStore.vm$;
    users$: Observable<IndexCard[]> = this.resourceplanStore.users$;
    caseUsers$: Observable<(IndexCard | {cardId: number, navn: string})[]> = this.resourceplanStore.caseUsers$;

    constructor(
        private readonly resourceplanStore: ResourceplanStore,
        private route: ActivatedRoute,
        private casesDispatch: CasesDispatchers,
        private router: Router,
        private casesService: CasesService,
        private alert: AlertService,
        @Optional() private activeModal: NgbActiveModal,
    ) { }

    ngOnInit() {
        this.route.params.pipe(
            tap(params => {
                const sagId = this.sagId || params.sagid;
                if (sagId) {
                    this.resourceplanStore.init(sagId);
                }
            })
        ).subscribe();
    }

    ngOnDestroy() {
        this.casesDispatch.loadCases();
    }

    createTimeBudget(timeBudget: TimeBudget) {
        this.resourceplanStore.createTimeBudget(timeBudget).subscribe();
    }

    updateTimeBudget(timeBudget: TimeBudget) {
        this.resourceplanStore.updateTimeBudget(timeBudget).subscribe();
    }
    deleteTimeBudget(id: number) {
        this.resourceplanStore.deleteTimeBudget(id).subscribe();
    }

    updateClientCaseV2(payload: {sag: SagView, partialSag: Partial<SagView>}) {
        this.resourceplanStore.updateClientCaseV2(payload.sag, payload.partialSag).subscribe();
    }

    updateClientCaseV2WithReNavigte(payload: { sag: SagView; partialSag: Partial<SagView> }) {
        this.resourceplanStore.updateClientCaseV2(payload.sag, payload.partialSag).pipe(
            tap(() => {
                if (!this.sagId) {
                    this.router.navigate(['./'], { relativeTo: this.route} );
                }
            })
        ).subscribe();
    }

    removeCaseUser(userToRemove: number, timeBudgets: TimeBudget[]) {
        const userTimeBudgets = timeBudgets.filter(t => t.medID === userToRemove);
        const userHours = userTimeBudgets.reduce((p, c) => p + c.timer, 0);
        if (userTimeBudgets.length > 0 && userHours === 0) {
            const timeBudgetsZeroIds = userTimeBudgets.filter(t => t.timer === 0).map(tb => tb.oid);
            return this.casesService.deleteTimeBudgets(timeBudgetsZeroIds).pipe(
                map(() => this.resourceplanStore.removeCaseUser(userToRemove)),
                catchError(() => EMPTY)
            ).subscribe();
        }
        if (userTimeBudgets.length > 0 && userHours > 0) {
            this.alert.createAlert('Medarbejdere med planlagte timer kan ikke fjernes!', 'danger');
            this.resourceplanStore.addCaseUser(userToRemove);
            return;
        }
        this.resourceplanStore.removeCaseUser(userToRemove);
    }

    addCaseUser(userToAdd: number) {
        this.resourceplanStore.addCaseUser(userToAdd);
    }

    onClose() {
        this.activeModal.close();
    }
}
